import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AdminAuthState {
  token: string;
  env: string;
  isMerchantAuthRep: boolean | null;
  userId: string;
  email: string;
  regtankOnboardingFeatureFlag: boolean | null;
  userFirstName: string | null;
  userLastName: string | null;
}

const initialState: AdminAuthState = {
  token: "none",
  env: "none",
  isMerchantAuthRep: null,
  userId: "",
  email: "",
  regtankOnboardingFeatureFlag: null,
  userFirstName: null,
  userLastName: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<{ token: string }>) => {
      state.token = action.payload.token;
    },
    setEnvironment: (state, action: PayloadAction<{ env: string }>) => {
      state.env = action.payload.env;
    },
    setIsMerchantAuthRep: (state, action: PayloadAction<{ isMerchantAuthRep: boolean | null }>) => {
      state.isMerchantAuthRep = action.payload.isMerchantAuthRep;
    },
    setRegtankOnboardingFlag: (
      state,
      action: PayloadAction<{ regtankOnboardingFeatureFlag: boolean | null }>,
    ) => {
      state.regtankOnboardingFeatureFlag = action.payload.regtankOnboardingFeatureFlag;
    },
    setUserFirstName: (state, action: PayloadAction<{ userFirstName: string | null }>) => {
      state.userFirstName = action.payload.userFirstName;
    },
    setUserLastName: (state, action: PayloadAction<{ userLastName: string | null }>) => {
      state.userLastName = action.payload.userLastName;
    },
    setUserEmail: (state, action: PayloadAction<{ email: string }>) => {
      state.email = action.payload.email;
    },
    resetAuthState: () => initialState,
  },
});

export const {
  setToken,
  setEnvironment,
  resetAuthState,
  setRegtankOnboardingFlag,
  setIsMerchantAuthRep,
  setUserFirstName,
  setUserLastName,
  setUserEmail,
} = authSlice.actions;
export default authSlice.reducer;
